
if($('.js-tab-list').length) {

  $(window).on('load', function(){
    $('.js-tab-list').parent('.js-tab-fixed').removeClass('fixed');
  });
  $(function(){
    var fix    = $('.js-tab-list').parent('.js-tab-fixed');
    var fixTop = fix.offset().top;
    var fixTop = fixTop;
      $(window).scroll(function () {
        if($(window).scrollTop() >= fixTop) {
          fix.addClass('fixed');
          if($('.result-upper').length) {
            $('.result-upper').addClass('fixed');
          }
        } else {
          fix.removeClass('fixed');
          if($('.result-upper').length) {
            $('.result-upper').removeClass('fixed');
          }
        }
      });
  });
};

if ($('.year-application-sort-input').length) {
  $(document).on('change', '.year-application-sort-input', function(){
    let url = (location.search) ? location.search + '&' : location.search + '?';
    location.href=url + 'c_recruit_y=' + (($(this).prop('checked')) ? 1 : 0);
  });
}
// .student-search
if ($('#sidebarOpenBtn').length) {
  $('#sidebarOpenBtn').on('click', function() {
    $(this).next('.wrapper').slideToggle();
    $(this).toggleClass('open');
  });
$(window).on('load resize', function () {
  var wid = window.innerWidth;

  if (wid > 991) { // breakpoint設定する
    $('#sidebarOpenBtn').next('.wrapper').show();
    $('#sidebarOpenBtn').removeClass('open');
  }else if(wid <= 992) {
    $('#sidebarOpenBtn').next('.wrapper').hide();
    $('#sidebarOpenBtn').removeClass('open');
  }
});
}

$(function(){
    $('.__PrivateStripeElement iframe').on('load', function(){
        $('.__PrivateStripeElement iframe').contents().find('.InputElement').css('height','auto');
    });
});